import { render, staticRenderFns } from "./ItemIndex.vue?vue&type=template&id=3cd27431&scoped=true&"
import script from "./ItemIndex.vue?vue&type=script&lang=js&"
export * from "./ItemIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd27431",
  null
  
)

export default component.exports